import styled from "styled-components";
import FormBar from "./form-bar/form-bar";
import AdSection from "./components/AdSection";
import Opinions from "./components/Opinions";
import OurServices from "./components/OurServices";
import StoringPlace from "./components/StoringPlace";
import StoringTerms from "./components/StoringTerms";
import Support from "./components/Supprot";
import TypesOfGoods from "./components/TypesOfGoods";
import WarehousesMap from "./warehouses-map";
import { useQuery } from "@tanstack/react-query";
import { getAllWarehouses } from "../../../services/warehouses/get-all";
import { useAppDispatch } from "../../../hooks/redux-hooks";
import { LoadingBackDrop } from "../../../components/loader";
import { warehouses } from "../../../redux/actions";
import SessionService from "../../../services/session-service";

const UnloggedDashboard = () => {
  const dispatch = useAppDispatch();
  const body = {
    paginacja: null,
  };

  const { isLoading } = useQuery(["warehouses"], () => getAllWarehouses(body), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    onSuccess(data) {
      dispatch(warehouses.fetchAllWarehouses(data.data.payload.magazyny));
      SessionService.setWarehousesList(data.data.payload.magazyny);
    },
  });
  if (isLoading) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <PageContainer>
      <FormBar />
      <AdSection />
      <OurServices />
      {/* <WarehousesMap /> */}
      <StoringPlace />
      <StoringTerms />
      <Opinions />
      <TypesOfGoods />
      <Support />
    </PageContainer>
  );
};

export default UnloggedDashboard;
const PageContainer = styled.div`
  width: 100%;
  display: flex;
  //justify-content: center;
  align-items: center;
  flex-direction: column;
`;
